module.exports = __webpack_public_path__ + "static/media/Grupo1.a5e8ae2d.svg";